const status = {
    OK: 'OK',
    PENDING: 'PENDING',
    ERROR: 'ERROR',
}

export default status
